import { Button, Typography } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import InstructionsContent from './InstructionsContent';
import './InstructionsScreen.scss';

interface Props {
  onStart: () => void;
}

function InstructionsScreen({ onStart }: Props) {
  return (
    <div className="instructions-screen">
      <div className="instructions-card">
        <Typography.Title level={3} style={{ marginBottom: 4 }}>
          Before you begin
        </Typography.Title>
        <Typography.Paragraph type="secondary" style={{ marginBottom: 24 }}>
          Please read through the instructions below before starting your
          simulation assessment.
        </Typography.Paragraph>

        <InstructionsContent />

        <div className="instructions-start-action">
          <Button
            type="primary"
            size="large"
            icon={<PlayCircleOutlined />}
            onClick={onStart}
          >
            Start Simulation
          </Button>
        </div>
      </div>
    </div>
  );
}

export default InstructionsScreen;
